import React from "react";
import "../css/VariantPlan.css";
import AccommodationItem from "./AccommodationItem";
import AttractionItem from "./AttractionItem";
import IndividualTransportItem from "./IndividualTransportItem";
import TransportItem from "./TransportItem";
import TrekkingItem from "./TrekkingItem";

const VariantPlan = ({ tripPlan }) => {
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatDayName = (dateString) => {
        const [day, month, year] = dateString.split('.').map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("pl-PL", { weekday: "long" }).replace(/^./, (char) => char.toUpperCase());;
    }


  const groupedByDate = tripPlan.reduce((acc, item) => {
    const day = formatDate(item.startDate);
    if (!acc[day]) acc[day] = [];
    acc[day].push(item);
    return acc;
  }, {});

  const renderElement = (item) => {
    switch (item.type) {
      case 0: 
        return <AttractionItem item={item} />;
      case 1: 
        return <AccommodationItem item={item} />;
      case 2: 
        return <IndividualTransportItem item={item} />;
      case 3:
        return <TransportItem item={item} />;
      case 4: 
        return <TrekkingItem item={item} />;
      default:
        return null;
    }
  };

  return (
    <div className="variant-plan">
      <h2>Plan wycieczki</h2>
      {Object.entries(groupedByDate).map(([day, items]) => (
        <div key={day} className="day-group">
          <h3 className="day-title">{day} - {formatDayName(day)}</h3>
          <div className="day-items">
            {items
              .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
              .map((item, index) => (
                <div key={index} className="plan-element">
                  {renderElement(item)}
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VariantPlan;
